// @flow

import * as React from 'react';

import { trackBrowsedPreviewImages } from 'search/analytics';

import PreviewImage, { NextButton, PreviousButton } from './PreviewImage';
import VenueLink from 'common/components/venueCard/VenueLink';

import type { VenueResult } from 'search/types';

import styles from './PreviewImages.scss';

export type PreviewImageType = {|
  url: string | null,
  placeholder: string | null
|};

type Props = {|
  venue: VenueResult,
  openInNewTab: boolean,
  onClickVenueLink?: () => void
|};

type State = {|
  index: number,
  images: Array<PreviewImageType>
|};

const firstImageIndex = 0;

export default class PreviewImages extends React.Component<Props, State> {
  viewedImageIndices: Set<number>;

  constructor(props: Props) {
    super(props);

    const { preview_images: images = [] } = this.props.venue;
    this.state = {
      index: 0,
      images: images
    };
    //Not used in render
    this.viewedImageIndices = new Set([firstImageIndex]);
  }

  render() {
    const { index, images } = this.state;
    const { venue, openInNewTab, onClickVenueLink } = this.props;
    const image = images[index];
    const showControls = images.length > 1;

    return (
      <div className={styles.container}>
        <VenueLink
          venue={venue}
          openInNewTab={openInNewTab}
          onClickVenueLink={onClickVenueLink}
        >
          <PreviewImage image={image} />
        </VenueLink>
        {showControls && <NextButton handleClick={this.nextImage} />}
        {showControls && <PreviousButton handleClick={this.prevImage} />}
      </div>
    );
  }

  nextImage: () => void = () => {
    this.setState((prevState: State) => {
      const newIndex = nextIndex(prevState);
      this.trackViewedImage(newIndex);
      return { index: newIndex };
    });
  };

  prevImage: () => void = () => {
    this.setState((prevState: State) => {
      const newIndex = prevIndex(prevState);
      this.trackViewedImage(newIndex);
      return { index: newIndex };
    });
  };

  trackViewedImage: number => void = imageIndex => {
    this.viewedImageIndices.add(imageIndex);
    trackBrowsedPreviewImages(this.viewedImageIndices.size, this.props.venue);
  };
}

function nextIndex(state: State): number {
  const {
    index: currIdx,
    images: { length: imagesCount }
  } = state;
  return (currIdx + 1) % imagesCount;
}

function prevIndex(state: State): number {
  const {
    index: currIdx,
    images: { length: imagesCount }
  } = state;
  return (currIdx + imagesCount - 1) % imagesCount;
}
